import CompanyContainer from "../containers/company_container";

export default function Company() {
    // const token = useToken();
    // if ( token===null ){
    //     return <Redirect to="/signin" />
    // }
    return <CompanyContainer />
}
